import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setUserArticle } from '../../store/user/userSlice';

/**
 * DemoLogin Component
 * 
 * Automatic demo login route accessible at /demo
 * Perfect for linking from external sites (dizee.com → diz.ee/demo)
 * 
 * Usage: Link to https://diz.ee/demo from your main site
 */
function DemoLogin() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        // Clear any existing session first
        localStorage.removeItem('dizeeUser');
        localStorage.removeItem('dizeeToken');
        
        // Set demo user data
        const demoUser = {
            _id: 'demo_user_' + Date.now(),
            email: 'demo@dizee.app',
            username: 'Demo User',
            name: 'Demo User',
            professionRole: 'artist', // Must be 'artist' to access app routes
            isDemo: true,
            restrictions: {
                canCreate: false,
                canEdit: false,
                canDelete: false,
                canExport: false,
                canInvite: false,
                canAccessFinancials: false,
                canManageTeam: false,
            }
        };
        
        // Token should be a simple string (will be JSON.stringify'd when stored)
        const demoToken = 'demo_token_' + Date.now();
        
        // Store in localStorage (matching the format from authThunk.js)
        localStorage.setItem('dizeeUser', JSON.stringify(demoUser));
        localStorage.setItem('dizeeToken', JSON.stringify(demoToken));
        
        // CRITICAL: Set user in Redux store
        dispatch(setUserArticle(demoUser));
        
        // Small delay to show loading, then redirect
        setTimeout(() => {
            // Force a full page reload to ensure App.js picks up the new token
            window.location.href = '/';
        }, 800);
    }, [navigate, dispatch]);

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: '#000000',
            color: '#ffffff'
        }}>
            <div style={{ textAlign: 'center' }}>
                {/* Simple loading spinner */}
                <div style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid rgba(255, 255, 255, 0.1)',
                    borderTop: '4px solid #667eea',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px'
                }} />
                
                <p style={{ 
                    fontSize: '14px',
                    marginTop: '16px',
                    opacity: 0.8
                }}>
                    Loading demo mode...
                </p>
                
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        </div>
    );
}

export default DemoLogin;

